import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Target, Users, ShieldCheck, Star, Zap, ChevronRight, Activity, PlayCircle, Dumbbell } from 'lucide-react';
import './Services.css';

const Services = () => {
    const sports = [
        { name: 'Football', icon: <PlayCircle />, desc: 'Elite tactical development and technical skills training for all age groups.' },
        { name: 'Cricket', icon: <Zap />, desc: 'Mako-certified coaching for batting, bowling, fielding, and game strategy.' },
        { name: 'Hockey', icon: <Activity />, desc: 'Professional pathways with a proven record of provincial selection success.' },
        { name: 'Tennis', icon: <Target />, desc: 'Technique-focused drills for power, precision, agility, and match play.' },
        { name: 'Basketball', icon: <Trophy />, desc: 'Full-court training focusing on endurance, teamwork, and competitive excellence.' },
        { name: 'Conditioning', icon: <Dumbbell />, desc: 'High-performance fitness and strength training for all sports disciplines.' }
    ];

    const highlights = [
        { title: 'Inclusive Access', icon: <Users />, desc: 'Comprehensive sports programs for boys and girls aged 5–21 years.' },
        { title: 'Expert Mentorship', icon: <Star />, desc: 'Professional guidance to provincial and national selection levels.' },
        { title: 'Community Impact', icon: <ShieldCheck />, desc: 'Building discipline, character, and leadership through athletics.' }
    ];

    return (
        <section className="services-gallery" id="academy">
            <div className="container">
                {/* Header */}
                <div className="services-gallery__header">
                    <motion.span
                        className="services-gallery__eyebrow"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                    >
                        Our Disciplines
                    </motion.span>
                    <motion.h2
                        className="services-gallery__title"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.1 }}
                    >
                        WORLD-CLASS <span className="services-gallery__title--accent">ACADEMY PROGRAMS</span>
                    </motion.h2>
                    <motion.p
                        className="services-gallery__subtitle"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                    >
                        Professional coaching across multiple sports disciplines with proven pathways to competitive excellence
                    </motion.p>
                </div>

                {/* Programs Grid */}
                <div className="services-gallery__grid">
                    {sports.map((sport, idx) => (
                        <motion.article
                            key={sport.name}
                            className="services-gallery__card"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: idx * 0.1, duration: 0.6 }}
                        >
                            <div className="services-gallery__icon">
                                {React.cloneElement(sport.icon, { size: 32 })}
                            </div>
                            <h3 className="services-gallery__card-title">{sport.name}</h3>
                            <p className="services-gallery__card-description">{sport.desc}</p>
                            <div className="services-gallery__card-link">
                                Learn More <ChevronRight size={16} />
                            </div>
                        </motion.article>
                    ))}
                </div>

                {/* Why Choose Us */}
                <motion.div
                    className="services-gallery__highlights"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="services-gallery__highlights-grid">
                        {highlights.map((h, i) => (
                            <motion.div
                                key={h.title}
                                className="services-gallery__highlight"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.2 }}
                            >
                                <div className="services-gallery__highlight-icon">
                                    {React.cloneElement(h.icon, { size: 28 })}
                                </div>
                                <h4 className="services-gallery__highlight-title">{h.title}</h4>
                                <p className="services-gallery__highlight-description">{h.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Services;
